<ca-card>
    <div ca-card-content>
        <div>    
            <ca-card>
                <div ca-card-title>{{'COMUN.DATOS_PERSONA.TITULO' | translate}} {{'COMUN.DATOS_PERSONA.TIPO_PERSONA.CLIENTE_TOMADOR' | translate}}</div>
                <div ca-card-content>                    
                    <app-datos-personales [config]="tomadorConfig"></app-datos-personales>                    
                </div>
            </ca-card>
        </div>
        <div class="mt-3">
            <ca-card>
                <div ca-card-title>
                    {{'COMUN.DATOS_DOMICILIO.TITULO' | translate}}  
                    {{'COMUN.DATOS_PERSONA.TIPO_PERSONA.CLIENTE_TOMADOR' | translate}}
                </div>
                <div ca-card-content>
                    <app-datos-domicilio [config]="domicilioTomadorConfig"></app-datos-domicilio>
                </div>
            </ca-card>
        </div>
        <div class="mt-3">       
            <ca-card>
                <div ca-card-title>{{'COMUN.DATOS_CONTACTO.TITULO' | translate}}</div>
                <div ca-card-content>
                    <app-datos-contacto 
                        [datosContacto]="poliza.tomador?.datosContacto || []"
                        [editable]="false"></app-datos-contacto>
                </div>
            </ca-card>
        </div>

        <div class="mt-3">
            <ca-card>
                <div ca-card-title>
                    {{'COMUN.DATOS_DOMICILIO.TITULO' | translate}}  
                    {{'DATOS_SOLICITUD.CLIENTE.PRESTACION' | translate}}
                </div>
                <div ca-card-content>
                    <app-datos-domicilio [config]="domicilioPrestacionConfig"></app-datos-domicilio>
                </div>
            </ca-card>
        </div>
        <div class="mt-3">
            <ca-card>
                <div ca-card-title>
                    {{'CATALOGO.DATOS_PAGO.TITULO' | translate}}
                </div>
                <div ca-card-content>
                    <app-datos-pago 
                        [cuenta]="poliza.medioPago?.cuentaBancaria"
                        [editable]="false"></app-datos-pago>
                </div>
            </ca-card>
        </div>
        <div class="mt-3" *ngIf="poliza.companiaProcedencia">
            <app-datos-complementarios [companiaProcedencia]="poliza.companiaProcedencia"></app-datos-complementarios>
        </div>
    </div>
</ca-card>